import { AppWindow } from 'lucide-react';

import type { EmbedContent, ScriptElement } from '@/lib/schema.types';

export function EmbedElement({ element, isSelected }: { element: ScriptElement; isSelected: boolean }) {
  const c = element.content as EmbedContent | undefined;
  const html = c?.html?.trim();
  if (!html && !c?.url) {
    return (
      <div className="flex aspect-video w-full items-center justify-center rounded-md bg-black/5 text-fg-subtle">
        <AppWindow size={20} />
      </div>
    );
  }
  return (
    <iframe
      // Raw HTML (simulation) via srcDoc takes precedence over a website URL.
      {...(html ? { srcDoc: html } : { src: c!.url })}
      className="block w-full rounded-md bg-white"
      style={{ height: c?.height ?? 320, pointerEvents: isSelected ? 'auto' : 'none' }}
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      title={`embed-${element.id}`}
    />
  );
}
